import { type ReactNode } from "react";
import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import { useExternalContent } from "~/features/configurator/Linear/hooks/useExternalContent";
import { useTranslation } from "react-i18next";
import { Alert } from "~/common/mui/Alert/Alert";

interface Props {
  content: string | undefined;
  error?: ReactNode; // What to show in case of error - set to null to not show anything
  loading?: ReactNode; // What to show when loading - set to null to not show anything
  as?: keyof JSX.IntrinsicElements;
}

const SimpleExternalContent = ({
  error = <DefaultErrorMsg />,
  loading = <CircleSpinner />,
  content,
  as = "div",
}: Props) => {
  const { state, content: externalContent } = useExternalContent(content);

  const Tag = as;

  return (
    <>
      {state === "loading" && loading}
      {state === "error" && error}
      {state === "loaded" && <Tag dangerouslySetInnerHTML={{ __html: externalContent! }} />}
    </>
  );
};
export default SimpleExternalContent;

const DefaultErrorMsg = () => {
  const { t } = useTranslation();
  return <Alert severity={"error"}>{t("externalContent.error")}</Alert>;
};

SimpleExternalContent.DefaultErrorMsg = DefaultErrorMsg;
